import { useMemo } from 'react';
import useUIContext from '~/ui/use-ui-context.ts';
import contextualPathTransformer from '../utils/contextual-path-transformer.js';

const useContextualPathTransformer = () => {
	const { contexts } = useUIContext();
	const memoized = useMemo(() => contextualPathTransformer(contexts), [contexts]);
	return memoized;
};

export default useContextualPathTransformer;
